import { Controller } from "@hotwired/stimulus";
// import $ from "jquery";
// import "bootstrap-fileinput/js/fileinput";

export default class extends Controller {
  static values = {
    imageUrl: String
  };

  connect() {
    // let $el = $(this.element);
    // $el.fileinput({
    //   initialPreview: [this.imageUrlValue],
    //   initialPreviewAsData: true,
    //   initialPreviewShowDelete: false,
    //   initialPreviewConfig: [
    //     {
    //       caption: "Moon.jpg",
    //       // downloadUrl: url1,
    //       description: "<h5>The Moon</h5>The Moon is Earth's only natural satellite and the fifth largest moon in the solar system. The Moon's distance from Earth is about 240,000 miles (385,000 km).",
    //       size: 930321,
    //       width: "120px",
    //       key: 1
    //     },
    //   ],
    //   showUpload: false,
    //   showRemove: false,
    //   showRotate: false,
    //   showZoom: false,
    //   // dropZoneEnabled: false,
    //   maxFileCount: 1,
    //   allowedFileExtensions: ["jpg", "png", "gif"],
    //   msgPlaceholder: "Hiyah",
    //   browseOnZoneClick: true,
    //   overwriteInitial: true
    // });
  }
}
